import {
  React,
  Component,
} from 'imports/CommonImports';

import {
  Paper,
} from 'material-ui';

import {PrimaryButton} from 'imports/DesignImports';

const styles = {
  container: {
    padding: '0.1em 0 2em 0',
  },
  title: {
    paddingLeft: '1em',
    marginBottom: '1.5em',
  },
  videoContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
  button: {
    width: '15em',
  },
}

class WelcomeVideo extends Component {
  state = {
    loadingDialog: false,
  }
  render() {
    let user = this.props.user
    return (
      <Paper style={styles.container}>
        <h1 style={styles.title}>Hola {user.first_name} {user.last_name} !</h1>
        <div style={styles.videoContainer}>
          <iframe title="welcome-video" width="700" height="400"
            allowFullScreen
            frameBorder="0"
            src="https://www.youtube.com/embed/u-OLOPr9lA0">
          </iframe>
        </div>
        <div style={styles.buttonContainer}>
          <PrimaryButton label='Continuar' onClick={() => this.props.close('CG')} />
        </div>
       </Paper>
    );
  }
}

export default WelcomeVideo;



// WEBPACK FOOTER //
// ./src/components/setup/WelcomeVideo.js